import { apiService } from './apiService';

export const whatsappService = {
  async send(data: { phoneNumber: string; message?: string; templateName?: string; templateLanguageCode?: string }) {
    return apiService.post('/whatsapp-send', data);
  },
};
